<template>
  <div ref="container" class="xl:col-span-8 text-center">
    <step-title :title="'Turundus'"/>
    <div class="md:max-w-xl mx-auto">
      <StepFiveHexagonGrid/>
    </div>
  </div>
</template>

<script>
import StepFiveHexagonGrid from "../calculator-steps-hexagon-grid/StepFiveHexagonGrid";
import calculatorSteps from "@/mixins/calculatorSteps";
import StepTitle from "@/components/calculator-steps/utils/StepTitle";


export default {
  name: "CalculatorGoogle",
  components: {
    StepFiveHexagonGrid,
    StepTitle
  },
  mixins: [calculatorSteps]
};
</script>

<style>
</style>
